import { render, staticRenderFns } from "./BlackCurrentConsume.vue?vue&type=template&id=e9fe2e98&scoped=true"
import script from "./BlackCurrentConsume.vue?vue&type=script&lang=js"
export * from "./BlackCurrentConsume.vue?vue&type=script&lang=js"
import style0 from "./BlackCurrentConsume.vue?vue&type=style&index=0&id=e9fe2e98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fe2e98",
  null
  
)

export default component.exports